import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=177d7a3e&scoped=true&"
import script from "./Search.vue?vue&type=script&setup=true&lang=js&"
export * from "./Search.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d7a3e",
  null
  
)

export default component.exports